module.exports = __webpack_public_path__ + "static/media/Rasp_Small.2844c0e1.webp";